import React                 from 'react';
import classNames            from 'classnames';
import IconButton            from '@material-ui/core/IconButton';
import { Theme, makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon         from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon      from '@material-ui/icons/ArrowForward';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  dateSelection: {
    margin: '0px 10px',
    width: '130px',
  },
  dateArrow: {
    color: theme.palette.success.main,
    '&:hover': {
      background: 'none',
      backgroundColor: theme.palette.success.main,
      color: 'white',
    },
  },
});

interface IDateNavProps {
  className?        : string;
  classes?          : any;
  disableNavigation?: boolean;
  DateComponent     : React.FunctionComponent<any>;
  onPreviousClick   : (() => void);
  onNextClick       : (() => void);
}

const useDateNavStyles = makeStyles(styles);
export default (props: IDateNavProps) => {
  const classes       = useDateNavStyles(props);
  const {
    className,
    disableNavigation,
    DateComponent,
    onPreviousClick,
    onNextClick,
  }                   = props;

  return (
    <div className={classNames(classes.root, className)}>
      <IconButton className={classes.dateArrow} disabled={!!disableNavigation} disableRipple={true} onClick={() => onPreviousClick()}>
        <ArrowBackIcon />
      </IconButton>
      <DateComponent className={classes.dateSelection} />
      <IconButton className={classes.dateArrow} disabled={!!disableNavigation} disableRipple={true} onClick={() => onNextClick()}>
        <ArrowForwardIcon />
      </IconButton>
    </div>
  );
};
